import { render, staticRenderFns } from "./LeaderNgSpecialOfferReceipt.vue?vue&type=template&id=0a703840&scoped=true&"
import script from "./LeaderNgSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
export * from "./LeaderNgSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderNgSpecialOfferReceipt.vue?vue&type=style&index=0&id=0a703840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a703840",
  null
  
)

export default component.exports